import { createGlobalState } from 'react-use';

const archiveModal = createGlobalState(false);
const copyModal = createGlobalState(false);
const createModal = createGlobalState(false);
const createCampaignModal = createGlobalState(false);
const deleteModal = createGlobalState(false);
const moveModal = createGlobalState(false);
const renameModal = createGlobalState(false);
const unarchiveModal = createGlobalState(false);

export enum CampaignFolderModals {
  All = 'all',
  Archive = 'archive',
  Copy = 'copy',
  Create = 'create', // for folder creation
  CreateCampaign = 'createCampaign',
  Delete = 'delete',
  Move = 'move',
  Rename = 'rename',
  Unarchive = 'unarchive',
}
/**
 * This hook creates a global state that can be used to track campaign folder modals and selectively
 * open and close them from any component without having to pass props around
 */
export function useCampaignFolderModals() {
  const [showArchiveModal, setShowArchiveModal] = archiveModal();
  const [showCopyModal, setShowCopyModal] = copyModal();
  const [showCreateModal, setShowCreateModal] = createModal();
  const [showCreateCampaignModal, setShowCreateCampaignModal] = createCampaignModal();
  const [showDeleteModal, setShowDeleteModal] = deleteModal();
  const [showMoveModal, setShowMoveModal] = moveModal();
  const [showRenameModal, setShowRenameModal] = renameModal();
  const [showUnarchiveModal, setShowUnarchiveModal] = unarchiveModal();

  return {
    [CampaignFolderModals.All]: {
      // any shown (property name kept for consistency)
      isShown:
        showArchiveModal ||
        showCopyModal ||
        showCreateModal ||
        showCreateCampaignModal ||
        showDeleteModal ||
        showMoveModal ||
        showRenameModal ||
        showUnarchiveModal,
      // toggle all off only (property name kept for consistency)
      toggle: () => {
        setShowArchiveModal(false);
        setShowCopyModal(false);
        setShowCreateModal(false);
        setShowCreateCampaignModal(false);
        setShowDeleteModal(false);
        setShowMoveModal(false);
        setShowRenameModal(false);
        setShowUnarchiveModal(false);
      },
    },
    [CampaignFolderModals.Archive]: {
      isShown: showArchiveModal,
      toggle: (newState?: boolean) => {
        setShowArchiveModal(newState ?? !showArchiveModal);
      },
    },
    [CampaignFolderModals.Copy]: {
      isShown: showCopyModal,
      toggle: (newState?: boolean) => {
        setShowCopyModal(newState ?? !showCopyModal);
      },
    },
    [CampaignFolderModals.Create]: {
      isShown: showCreateModal,
      toggle: (newState?: boolean) => {
        setShowCreateModal(newState ?? !showCreateModal);
      },
    },
    [CampaignFolderModals.CreateCampaign]: {
      isShown: showCreateCampaignModal,
      toggle: (newState?: boolean) => {
        setShowCreateCampaignModal(newState ?? !showCreateCampaignModal);
      },
    },
    [CampaignFolderModals.Delete]: {
      isShown: showDeleteModal,
      toggle: (newState?: boolean) => {
        setShowDeleteModal(newState ?? !showDeleteModal);
      },
    },
    [CampaignFolderModals.Move]: {
      isShown: showMoveModal,
      toggle: (newState?: boolean) => {
        setShowMoveModal(newState ?? !showMoveModal);
      },
    },
    [CampaignFolderModals.Rename]: {
      isShown: showRenameModal,
      toggle: (newState?: boolean) => {
        setShowRenameModal(newState ?? !showRenameModal);
      },
    },
    [CampaignFolderModals.Unarchive]: {
      isShown: showUnarchiveModal,
      toggle: (newState?: boolean) => {
        setShowUnarchiveModal(newState ?? !showUnarchiveModal);
      },
    },
  };
}
